import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Widget from "../../components/shared/Widget";
import styles from "../../thema/style";
class CategoriesWidget extends Component {
  render() {
    return (
      <Widget title={"Kategorİler"}>
        <ul>
          {this.props.category.categories.map((category, i) => (
            <li key={i}>
              <Link
                to={{
                  pathname: `/kategori/${category.slug}`,
                  state: { category: category }
                }}
              >
                {category.title}
              </Link>
            </li>
          ))}
        </ul>
      </Widget>
    );
  }
}

const mapStateToProps = ({ category, product }) => {
  return { category };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesWidget);



// WEBPACK FOOTER //
// ./src/components/shared/CategoriesWidget.js